import BgOrderBump from './images/order-bump.svg';
import BgChatWhatsApp from './images/chat-whatsapp.svg';
import BgElements from './images/elements.svg';
import BgTheme from './images/theme.svg';
import BgExitPopup from './images/exit-popup.svg';
import BgToast from './images/toast.svg';

const getSunFeatures = () => {
  return [
    {
      icon: 'orderBumpOutline',
      title: 'Order Bump',
      backgroundImage: BgOrderBump,
      description: 'Complemente a oferta do seu produto principal e aumente seu lucro em até 50%.',
      faqLink: 'https://ajuda.eduzz.com/hc/pt-br/articles/1260807006190-O-que-%C3%A9-e-como-cadastrar-o-Order-Bump-'
    },
    {
      icon: 'infoChatOutline',
      title: 'Chat e WhatsApp',
      backgroundImage: BgChatWhatsApp,
      description: 'Fortaleça a confiança com um canal direto para sanar as dúvidas de seus clientes.',
      faqLink: 'https://ajuda.eduzz.com/hc/pt-br/articles/5051961310619-Como-adicionar-chat-ao-meu-checkout-'
    },
    {
      icon: 'online',
      title: 'Elements',
      backgroundImage: BgElements,
      description: 'Facilite suas vendas integrando nosso checkout diretamente à sua página de vendas.',
      faqLink: 'https://ajuda.eduzz.com/hc/pt-br/articles/1260807004570-O-que-%C3%A9-o-Checkout-Elements-Sun-'
    },
    {
      icon: 'grid',
      title: 'Tema',
      backgroundImage: BgTheme,
      description: 'Fortaleça a identidade da sua marca e produto no visual do seu Checkout.',
      faqLink:
        'https://ajuda.eduzz.com/hc/pt-br/articles/4411284304283-Como-personalizar-minha-p%C3%A1gina-de-Checkout-'
    },
    {
      icon: 'exit',
      title: 'Exit Pop up',
      backgroundImage: BgExitPopup,
      description: 'Transforme indecisões em vendas: Capte a atenção dos clientes e feche mais negócios.',
      faqLink: 'https://ajuda.eduzz.com/hc/pt-br/articles/4403013603739-Como-configurar-o-desconto-de-sa%C3%ADda-'
    },
    {
      icon: 'notificationOutline',
      backgroundImage: BgToast,
      title: 'Toast',
      description: 'Habilite notificações e outros gatilhos para instigar o engajamento de seus clientes.'
    }
  ];
};

export default getSunFeatures;
